





















import { Vue, Component } from "vue-property-decorator";
import store from "@/general/store";
import CMS from "@/general/components/CMS.vue";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import CONST_DATA from "@/general/mixins/const/constData";
import AuthStorage from "@/general/utils/auth";


@Component({
  name: "CmsSpecialPageDetail",
  components: {
    CMS
  },
  store: store
})
export default class CmsSpecialPageDetail extends Vue {
  title: string | undefined | null = "";
  breadcrumb = [
    {
      text: "",
      url: CONST_DATA.SITE_MAP.TOP_PAGE,
      pageType: "home"
    },
    {
      text: "特集詳細",
      url: "",
      pageType: "lower"
    }
  ];

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get headerHeight(): number {
    // ランク利用表示フラグを見てヘッダーの高さを変える
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
  }
  get addMarginTop(): any {
    const style = {
      marginTop: this.headerHeight.toString() + "px"
    };
    return this.isSp ? style : "";
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.getBreadcrumb(this.breadcrumb);
  }

  setTitle(title: string) {
    this.title = title;
  }
}
